if (!customElements.get('af-promotion-ribbon')) {
  customElements.define('af-promotion-ribbon', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.storageKey = `af-promotion-ribbon:${this.dataset.campaignKey}`;
      if (!window.Shopify?.designMode) {
        try {
          if (sessionStorage.getItem(this.storageKey) === 'dismissed') this.hideRibbon();
        } catch (_) {
          // Dismissal still works when browser storage is unavailable.
        }
      }
      this.querySelector('.af-promotion-ribbon__close')?.addEventListener('click', () => {
        if (!window.Shopify?.designMode) {
          try { sessionStorage.setItem(this.storageKey, 'dismissed'); } catch (_) {}
        }
        document.querySelectorAll('af-promotion-ribbon').forEach(ribbon => {
          if (ribbon.dataset.campaignKey === this.dataset.campaignKey) ribbon.hideRibbon();
        });
      });
    }

    hideRibbon() {
      this.hidden = true;
      const section = this.closest('.shopify-section');
      if (section) section.hidden = true;
    }
  });
}
